import React, { useEffect, useState } from "react";
import "./report.css";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import {
    FilePath,
    viewcashbook,
    viewfolioledgerreport,
    viewfoliotrialreport,
    viewownersmissingpaymentmethod,
    viewpendinginvoices,
    viewpendingbills,
    viewownerspaymentmethoddetails
} from "../../../components/CommonSection/apiresources";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import { useLocation } from "react-router-dom";
import { Select, DatePicker } from "antd";
import moment from "moment";
const { Option } = Select;
const { RangePicker } = DatePicker;

const ViewReport = () => {
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [listViewDetails, setListViewDetails] = useState([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const reportName = queryParams.get("report") || "Report";

    const [dateFilterType, setDateFilterType] = useState("This Month");
    const [dateRange, setDateRange] = useState([
        moment().startOf("day"),
        moment().endOf("day"),
    ]);

   useEffect(() => {
    const today = moment();
    const startOfMonth = today.clone().startOf("month");
    const endOfMonth = today.clone().endOf("day");
    const lastMonthStart = today.clone().subtract(1, "month").startOf("month");
    const lastMonthEnd = today.clone().subtract(1, "month").endOf("month");

    let newRange = [today.clone().startOf("day"), today.clone().endOf("day")]; // default for Today

    if (dateFilterType === "This Month") {
        newRange = [startOfMonth, endOfMonth];
    } else if (dateFilterType === "Last Month") {
        newRange = [lastMonthStart, lastMonthEnd];
    }

    setDateRange(newRange);

    if (dateFilterType !== "Custom") {
        fetchInitialData(newRange);
    }
}, [dateFilterType]);


   

    const fetchInitialData = (rangeOverride = null) => {
    const userData = GetCookie("@UserData");
    if (userData) {
        const parsedData = JSON.parse(userData);
        getViewReportList(parsedData.agencyID, rangeOverride || dateRange);
    }
};


    const getViewReportList = (agencyID, overrideDateRange = null) => {
        const baseUrl =
            reportName === "Folio Ledger" ? viewfolioledgerreport
                : reportName === "Trial Report" ? viewfoliotrialreport
                    : reportName === "Cash Book" ? viewcashbook
                        : reportName === "Outstanding Bills" ? viewpendingbills
                            : reportName === "Owners without payment method" ? viewownersmissingpaymentmethod
                                : reportName === "Outstanding Invoices" ? viewpendinginvoices
                                    : reportName === "Contact and their bank details" ? viewownerspaymentmethoddetails
                                        : null;

        const [fromDate, toDate] = overrideDateRange || dateRange;

        const data = {
            AgencyId: agencyID,
            ...(reportName === "Trial Report" && {
                FromDate: fromDate.format("MM-DD-YYYY"),
                ToDate: toDate.format("MM-DD-YYYY"),
            }),
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setListViewDetails(reportName === "Trial Report" ? response.object : response.list);
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };


    const handleDateFilterChange = (value) => {
        setDateFilterType(value);

        const today = moment();
        let newRange;

        if (value === "Today") {
            newRange = [today.clone().startOf("day"), today.clone().endOf("day")];
        } else if (value === "This Month") {
            newRange = [today.clone().startOf("month"), today.clone().endOf("day")];
        } else if (value === "Last Month") {
            newRange = [
                today.clone().subtract(1, "month").startOf("month"),
                today.clone().subtract(1, "month").endOf("month"),
            ];
        } else {
            // For custom, just retain existing range and exit early
            return;
        }

        setDateRange(newRange);

        const userData = GetCookie("@UserData");
        if (userData) {
            const parsedData = JSON.parse(userData);
            getViewReportList(parsedData.agencyID, newRange);
        }
    };


    return (
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                <div className="material-work-desk-new bg-white m-3" style={{ maxHeight: "95vh" }}>
                    <div className="report-container">
                        <div className="report-toolbar">
                            <div className="left-tools">
                                <button className="btn"><i className="fa fa-print" /> Print</button>
                                <button className="btn"><i className="fa fa-file-pdf-o" /> PDF</button>
                                <button className="btn"><i className="fa fa-envelope" /> Send in Email</button>
                            </div>
                            <div className="filter-section-report">
                                <div className="d-flex align-items-center">
                                    <label className="mr-2">Transaction Date</label>
                                    <Select
                                        value={dateFilterType}
                                        onChange={(value) => handleDateFilterChange(value)}
                                        style={{ width: 160, marginRight: 10 }}
                                    >
                                        <Option value="Today">Today</Option>
                                        <Option value="This Month">This Month</Option>
                                        <Option value="Last Month">Last Month</Option>
                                        <Option value="Custom">Custom</Option>
                                    </Select>
                                    {dateFilterType === "Custom" ? (
                                        <RangePicker
                                            value={dateRange}
                                            format="DD/MM/YYYY"
                                            onChange={(dates) => setDateRange(dates)}
                                            style={{ marginRight: 10 }}
                                        />
                                    ) : (
                                        <>
                                            <DatePicker
                                                value={dateRange[0]}
                                                disabled
                                                format="DD/MM/YYYY"
                                                style={{ marginRight: 10 }}
                                            />
                                            <DatePicker
                                                value={dateRange[1]}
                                                disabled
                                                format="DD/MM/YYYY"
                                                style={{ marginRight: 10 }}
                                            />
                                        </>
                                    )}
                                    <button className="btn filter-btn-report">Filter</button>
                                </div>
                            </div>
                        </div>

                        <div className="report-header">
                            <h2>{reportName}</h2>
                            <p>From 1/03/2025 to 26/03/2025 by Transaction Date</p>
                        </div>

                        <div className="report-table-wrapper">
                            {reportName === "Folio Ledger" ? (
                                <div className="folio-ledger-wrapper">
                                    {["Owner folios", "Tenant folios"].map((section, i) => {
                                        const isOwner = section === "Owner folios";
                                        const filteredFolios = listViewDetails.filter(f =>
                                            isOwner ? f.folioType === 5 : f.folioType === 4
                                        );

                                        return (
                                            <div key={i} className="folio-group">
                                                <h5 style={{ marginBottom: "1rem" }}>{section}</h5>

                                                {filteredFolios.map((folio, index) => (
                                                    <div key={index} className="folio-section">
                                                        <h4>
                                                            {folio.folioReference} - ({folio.folioCode}) {folio.propertyAddress}
                                                        </h4>
                                                        <table className="report-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Audit</th>
                                                                    <th>Date</th>
                                                                    <th>Type</th>
                                                                    <th>Details</th>
                                                                    <th>Debit</th>
                                                                    <th>Credit</th>
                                                                    <th>Balance</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="opening-row">
                                                                    <td colSpan="6"><span>Opening balance</span></td>
                                                                    <td>${folio.openBal.toFixed(2)}</td>
                                                                </tr>
                                                                {folio.folioLedgerTransactionDetails.map((txn, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{txn.auditno}</td>
                                                                        <td>
                                                                            {txn.createdAt === "0001-01-01T00:00:00"
                                                                                ? ""
                                                                                : new Date(txn.createdAt).toLocaleDateString()}
                                                                        </td>
                                                                        <td>{txn.sTransactionType}</td>
                                                                        <td>{txn.details}</td>
                                                                        <td>{txn.debit > 0 ? `$${txn.debit.toFixed(2)}` : ""}</td>
                                                                        <td>{txn.credit > 0 ? `$${txn.credit.toFixed(2)}` : ""}</td>
                                                                        <td>${txn.balance.toFixed(2)}</td>
                                                                    </tr>
                                                                ))}
                                                                <tr className="closing-row">
                                                                    <td colSpan="6"><span>Closing balance</span></td>
                                                                    <td>${folio.balance.toFixed(2)}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <div className="subtotal-row">
                                                            <span className="debit-bal">
                                                                Debit: ${folio.debit.toFixed(2)} | Credit: ${folio.credit.toFixed(2)} | Balance: ${folio.balance.toFixed(2)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })}
                                </div>

                            ) : reportName === "Trial Report" ? (
                                <div className="folio-trial-wrapper">
                                    {[
                                        { key: "ownerFolioList", label: "Owner folios" },
                                        { key: "tenantFolioList", label: "Tenant folios" },
                                        { key: "supplierFolioList", label: "Supplier folios" },
                                    ].map((section, i) => {
                                        const folios = listViewDetails[section.key] || [];

                                        const total = folios.reduce(
                                            (acc, f) => {
                                                acc.opening += f.openingBalance || 0;
                                                acc.debit += f.debit || 0;
                                                acc.credit += f.credit || 0;
                                                acc.closing += f.closing || 0;
                                                return acc;
                                            },
                                            { opening: 0, debit: 0, credit: 0, closing: 0 }
                                        );

                                        return (
                                            <div key={i} className="folio-group">
                                                <h5 style={{ margin: "1rem 0" }}>{section.label}</h5>
                                                <table className="report-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Folio</th>
                                                            <th>Opening</th>
                                                            <th>Debit</th>
                                                            <th>Credit</th>
                                                            <th>Closing</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {folios.map((item, idx) => (
                                                            <tr key={idx}>
                                                                <td>{item.accountFolio} - {item.folioReference}</td>
                                                                <td>${item.openingBalance.toFixed(2)}</td>
                                                                <td>${item.debit.toFixed(2)}</td>
                                                                <td>${item.credit.toFixed(2)}</td>
                                                                <td>${item.closing.toFixed(2)}</td>
                                                                {/* <td>
                                                                    ${section.key === "tenantFolioList"
                                                                        ? (item.deposit ?? 0).toFixed(2)
                                                                        : (item.closing ?? 0).toFixed(2)}
                                                                </td> */}
                                                            </tr>
                                                        ))}
                                                        <tr className="subtotal-row" style={{ fontWeight: "bold", borderTop: "1px solid #ccc" }}>
                                                            <td>Total {section.label} Funds</td>
                                                            <td>${total.opening.toFixed(2)}</td>
                                                            <td>${total.debit.toFixed(2)}</td>
                                                            <td>${total.credit.toFixed(2)}</td>
                                                            <td>${total.closing.toFixed(2)}</td>
                                                            {/* <td>
                                                                ${section.key === "tenantFolioList"
                                                                    ? folios.reduce((sum, f) => sum + (f.deposit ?? 0), 0).toFixed(2)
                                                                    : total.closing.toFixed(2)}
                                                            </td> */}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : reportName === "Owners without payment method" ? (
                                <div className="folio-missing-payment-method">
                                    <h5 style={{ marginBottom: "1rem" }}>Owner Folios Missing Payment Method</h5>
                                    <table className="report-table">
                                        <thead>
                                            <tr>
                                                <th>Folio Code</th>
                                                <th>Property Address</th>
                                                <th>Owner Names</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listViewDetails.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{item.folioCode}</td>
                                                    <td>{item.propertyAddress}</td>
                                                    <td>
                                                        {item.ownerNames && item.ownerNames.length > 0
                                                            ? item.ownerNames.join(", ")
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : reportName === "Outstanding Invoices" ? (
                                <div className="folio-pending-invoices">
                                    <h5 style={{ marginBottom: "1rem" }}>Outstanding Invoices</h5>
                                    <table className="report-table">
                                        <thead>
                                            <tr>
                                                <th>Property</th>
                                                <th>Tenant</th>
                                                <th>Details</th>
                                                <th>Account</th>
                                                <th>Amount</th>
                                                <th>Date</th>
                                                <th>Processed By</th>
                                                <th>Attachment</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listViewDetails.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{item.propertyName}</td>
                                                    <td>{item.tenantName}</td>
                                                    <td>{item.details}</td>
                                                    <td>{item.accountName}</td>
                                                    <td>${item.amount?.toFixed(2)}</td>
                                                    <td>{new Date(item.date).toLocaleDateString()}</td>
                                                    <td>{item.processedBy}</td>
                                                    <td>
                                                        {item.attachment_Path ? (
                                                            <a href={`/uploads/${FilePath + item.attachment_Path}`} target="_blank" rel="noopener noreferrer">
                                                                View
                                                            </a>
                                                        ) : "N/A"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : reportName === "Outstanding Bills" ? (
                                <div className="folio-pending-bills">
                                    <h5 style={{ marginBottom: "1rem" }}>Outstanding Bills</h5>
                                    <table className="report-table">
                                        <thead>
                                            <tr>
                                                <th>Property</th>
                                                <th>Folio</th>
                                                <th>Supplier</th>
                                                <th>Details</th>
                                                <th>Account</th>
                                                <th>Amount</th>
                                                <th>Due Date</th>
                                                <th>Job Ref</th>
                                                <th>Attachment</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listViewDetails.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{item.propertyName}</td>
                                                    <td>{item.folio}</td>
                                                    <td>{item.supplier}</td>
                                                    <td>{item.details}</td>
                                                    <td>{item.accountName}</td>
                                                    <td>${item.amount?.toFixed(2)}</td>
                                                    <td>{new Date(item.dueDate).toLocaleDateString()}</td>
                                                    <td>{item.jobReference}</td>
                                                    <td>
                                                        {item.attachment_Path ? (
                                                            <a href={`/uploads/${FilePath + item.attachment_Path}`} target="_blank" rel="noopener noreferrer">
                                                                View
                                                            </a>
                                                        ) : "N/A"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : reportName === "Contact and their bank details" ? (
                                <div className="owner-payment-methods-wrapper">
                                    <h5 style={{ marginBottom: "1rem" }}>Owner Payment Method Details</h5>
                                    <table className="report-table">
                                        <thead>
                                            <tr>
                                                <th>Folio Code</th>
                                                <th>Property Address</th>
                                                <th>Owner Names</th>
                                                <th>Payment Method</th>
                                                <th>Account Name</th>
                                                <th>BSB</th>
                                                <th>Account Number</th>
                                                <th>Split</th>
                                                <th>Split Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listViewDetails.map((item, idx) => (
                                                (item.paymentMethods || []).map((pm, pmIdx) => (
                                                    <tr key={`${idx}-${pmIdx}`}>
                                                        <td>{item.folioCode}</td>
                                                        <td>{item.propertyAddress}</td>
                                                        <td>{item.ownerNames?.join(", ") || "N/A"}</td>
                                                        <td>{pm.sPaymentMethod}</td>
                                                        <td>{pm.accountName}</td>
                                                        <td>{pm.accountBSB}</td>
                                                        <td>{pm.accountNumber}</td>
                                                        <td>{pm.split}%</td>
                                                        <td>{pm.sSplitType}</td>
                                                    </tr>
                                                ))
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <table className="report-table">
                                    <thead>
                                        <tr>
                                            <th>Audit</th>
                                            <th>Date</th>
                                            <th>Ref</th>
                                            <th>Type</th>
                                            <th>Details</th>
                                            <th>Debit</th>
                                            <th>Credit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listViewDetails.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" style={{ textAlign: "center" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        ) : (
                                            listViewDetails.map((item) => (
                                                <tr key={item.auditNo}>
                                                    <td>{item.auditNo}</td>
                                                    <td>
                                                        {new Date(item.createdOn).toLocaleDateString()}
                                                    </td>
                                                    <td>{item.reference}</td>
                                                    <td>{item.type}</td>
                                                    <td>
                                                        From: {item.fromName} <br />
                                                        To: {item.toFolio} - {item.toName} <br />
                                                        {item.details}
                                                    </td>
                                                    <td>
                                                        {item.debit > 0 ? `$${item.debit.toFixed(2)}` : ""}
                                                    </td>
                                                    <td>
                                                        {item.credit > 0 ? `$${item.credit.toFixed(2)}` : ""}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewReport;
